import {
  GET_GENERAL_SUCCESS,
  GET_GENERAL_FAIL,
  RESET_GENERAL_STATE,
  RESET_ATTACHMENT_STATE,
  GET_ATTACHMENT_SUCCESS,
  GET_ATTACHMENT_FAIL,
  RESET_PROFILE_ATTACHMENT_STATE,
  GET_PROFILE_ATTACHMENT_SUCCESS,
  GET_PROFILE_ATTACHMENT_FAIL,
  RESET_THUMBNAIL_ATTACHMENT_STATE,
  GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  GET_THUMBNAIL_ATTACHMENT_FAIL,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAIL,
  GET_SERVICE_LIST_SUCCESS,
  GET_SERVICE_LIST_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  general: [],
  gift_products: [],
  products: [],
  payment_gateway: [],
  countries: [],
  payment_type: [],
  roleList: [],
  regions: [],
  manufacturers: [],
  categories: [],
  services: [],
  shipping_methods: [],
  shipping_type: [],
  customer_point_action: [],
  customer_groups: [],
  attachment: [],
  configurations: [],
  profileAttachment: [],
  approved_products: [],
  configuration_items: [],
  voucherList: [],
  serviceList: [],
}

const General = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GENERAL_SUCCESS:
      return {
        ...state,
        order_number: action.payload?.library?.number_of_orders,
        review_number: action.payload?.library?.number_of_reviews,
        payment_gateway: action.payload?.library?.payment_gateway,
        countries: action.payload?.library?.countries,
        payment_type: action.payload?.library?.payment_method,
        courier_list: action.payload?.library?.courier_service,
        roleList: action.payload?.library?.roles,
        shipping_methods: action.payload?.library?.shipping_methods,
        customer_point_action: action.payload?.library?.customer_point_action,
        customer_groups: action.payload?.library?.customer_groups,
        regions: action.payload?.library?.regions,
        manufacturers: action.payload?.library?.manufacturers,
        models: action.payload?.library?.models,
        categories: action.payload?.library?.categories,
        services: action.payload?.library?.services,
        services_type: action.payload?.library?.service_types,
        configurations: action.payload?.library?.configurations,
        gift_products: action.payload?.library?.gift_products,
        products: action.payload?.library?.products,
        approved_products: action.payload?.library?.approved_products,
        configuration_items: action.payload?.library?.configuration_items,
        school_contracts: action.payload?.library?.school_contracts,
        active_schools: action.payload?.library?.active_schools,
        is_student_portal: action.payload?.is_student_portal,
      }

    case GET_GENERAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachment: action.payload,
      }
    case GET_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PROFILE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        profileAttachment: action.payload,
      }
    case GET_PROFILE_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_THUMBNAIL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        thumbnailAttachment: action.payload,
      }
    case GET_THUMBNAIL_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VOUCHER_LIST_SUCCESS:
      return {
        ...state,
        voucherList: action.payload,
      }
    case GET_VOUCHER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SERVICE_LIST_SUCCESS:
      return {
        ...state,
        serviceList: action.payload,
      }
    case GET_SERVICE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_GENERAL_STATE:
      return {
        ...state,
      }

    case RESET_ATTACHMENT_STATE:
      return {
        ...state,
        attachment: [],
      }

    case RESET_THUMBNAIL_ATTACHMENT_STATE:
      return {
        ...state,
        thumbnailAttachment: [],
      }

    case RESET_PROFILE_ATTACHMENT_STATE:
      return {
        ...state,
        profileAttachment: []
      }
    default:
      return state
  }
}

export default General
